"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _CompletedContext = _interopRequireDefault(require("../CompletedContext"));
var debugPages = false;
var DEBUG = false;
var Page = exports.default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Page, _Component);
  var _super = (0, _createSuper2.default)(Page);
  function Page(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Page);
    _this = _super.call(this, props);
    _this.getInitialState = _this.getInitialState.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = _this.getInitialState();
    _this.ref = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  (0, _createClass2.default)(Page, [{
    key: "getInitialState",
    value: function getInitialState() {
      var children = this.props.children;
      if (typeof children !== "object" || children.length === undefined) {
        children = [children];
      }
      var tasksCompleted = [];
      var subPageTaskIndex = -1;
      var tasksRegistered = 0;
      var shouldShowSubPage = false;
      if (this.state) {
        if (this.state.tasksRegistered) {
          tasksRegistered = this.state.tasksRegistered;
        }
        if (this.state.tasksCompleted) {
          tasksCompleted = this.state.tasksCompleted;
        }
        if (this.state.shouldShowSubPage) {
          shouldShowSubPage = this.state.shouldShowSubPage;
        }
        if (this.state.subPageTaskIndex !== -1) {
          subPageTaskIndex = this.state.subPageTaskIndex;
        }
      }
      return {
        tasksCompleted: tasksCompleted,
        subPageTaskIndex: subPageTaskIndex,
        shouldShowSubPage: shouldShowSubPage,
        tasksRegistered: tasksRegistered,
        index: this.props.index
      };
    }
  }, {
    key: "isPage",
    value: function isPage() {
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevprops.index !== this.props.index) {
        // We're actually on a different Page, so reset our state
        this.setState(function (state, props) {
          var arr = [];
          arr.length = state.tasksRegistered;
          DEBUG && console.log("Page componentDidUpdate index setState tasksRegistered", state.tasksRegistered);
          return {
            tasksCompleted: arr,
            index: props.index
          };
        });
        return;
      }
      if (prevstate.tasksCompleted !== this.state.tasksCompleted || prevstate.taskId !== this.state.taskId) {
        var completed = true;
        for (var i = 0; i < this.state.tasksCompleted.length; ++i) {
          if (this.state.tasksCompleted[i] === false && i !== this.state.subPageTaskIndex) {
            completed = false;
          }
        }
        if (!completed && this.state.shouldShowSubPage) {
          this.setState({
            shouldShowSubPage: false
          });
        } else if (completed && !this.state.shouldShowSubPage) {
          this.setState({
            shouldShowSubPage: true
          });
        }
        if (completed && this.state.tasksCompleted[this.state.subPageTaskIndex] === false) {
          completed = false;
        }
        DEBUG && console.log("Page componentDidUpdate onCompleted", completed, this.state.taskId, this.state.tasksCompleted, this.state.subPageTaskIndex);
        this.context.onCompleted(completed, this.state.taskId);
        this.setState({
          completed: completed
        });
      }
      if (prevstate.shouldShowSubPage === false && this.state.shouldShowSubPage === true && this.state.subPageTaskIndex !== -1) {
        this.scrollToBottom();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      if (this.context && this.state.taskId === undefined) {
        this.context.registerPage(function (id) {
          _this2.taskId = id;
        });
      }
      DEBUG && console.log("Page componentDidMount", this.state.tasksRegistered);
      if (this.state.tasksRegistered === 0) {
        DEBUG && console.log("Page componentDidMount completing @@@@@@@@@@@@@", this.state.taskId);
        this.context.onCompleted(true, this.state.taskId);
        this.setState({
          completed: true
        });
      }
      if (this.ref && this.ref.current && !this.props.noFocus) {
        this.ref.current.focus();
        //console.log("Page focus")
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.context) {
        this.context.unregisterPage(this.state.taskId);
        this.setState({
          taskId: undefined
        });
      }
    }
  }, {
    key: "scrollToBottom",
    value: function scrollToBottom() {
      window.scrollTo({
        top: 99999,
        left: 0,
        behavior: "smooth"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
        _this$props$style$pad,
        _this$props$style;
      DEBUG && console.log("Page render");
      if (this.props.index !== this.state.index) {
        // Direct mutation required: children mount before the parent and
        // this is the only way we can set this before the children mount
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.tasksRegistered = 0;
        //this.state.tasksCompleted = []
        DEBUG && console.log("Page render this.props.index !== this.state.index state mutation");
      }
      var children = this.props.children;
      if (typeof children !== "object" || children.length === undefined) {
        children = [children];
      }
      return /*#__PURE__*/_react.default.createElement(_CompletedContext.default.Provider, {
        value: {
          registerTask: function registerTask(callback) {
            var id = _this3.state.tasksRegistered;
            DEBUG && console.log("Page context registerTask");
            // Direct mutation required: children mount before the parent and
            // this is the only way we can set this before the children mount
            // eslint-disable-next-line react/no-direct-mutation-state
            _this3.state.tasksRegistered = id + 1;
            _this3.setState(function (state, props) {
              var arr = state.tasksCompleted.slice();
              arr[id] = false;
              DEBUG && console.log("Page context registerTask setState", id, arr, state.tasksRegistered + 1);
              return {
                tasksCompleted: arr
              };
            }, function () {
              if (typeof callback === 'function') {
                callback(id);
              } else {
                console.warn("Invalid callback", callback);
              }
            });
          },
          registerPage: function registerPage(callback) {
            var id;
            //console.log("registered page", id)
            _this3.setState(function (state, props) {
              id = state.tasksRegistered;
              if (id !== state.tasksRegistered) {
                DEBUG && console.log("tasksRegistered mismatch (page)", id, state.tasksRegistered);
              }
              var arr = state.tasksCompleted.slice();
              arr[id] = false;
              return {
                tasksCompleted: arr,
                subPageTaskIndex: id,
                tasksRegistered: state.tasksRegistered + 1
              };
            }, function () {
              if (typeof callback === 'function') {
                callback(id);
              } else {
                console.warn("Invalid callback", callback);
              }
            });
          },
          unregisterPage: function unregisterPage(id) {
            if (id === undefined) {
              DEBUG && console.log("unregisterPage: undefined id. assigning ", _this3.state.subPageTaskIndex);
              id = _this3.state.subPageTaskIndex;
            }
            if (id !== _this3.state.subPageTaskIndex) {
              DEBUG && console.log("warning: id !== this.state.subPageTaskIndex!");
            }
            if (id !== _this3.state.tasksCompleted.length - 1) {
              DEBUG && console.log("!!!!!!!!!!!!!!! out of order page deregistration! undefined behavior");
            } else {
              DEBUG && console.log("unregistered page", id);
              _this3.setState(function (state, props) {
                var arr = state.tasksCompleted.slice();
                var tasksRegisteredNext = state.tasksRegistered - 1 > 0 ? state.tasksRegistered - 1 > 0 : 0;
                arr.length = id;
                return {
                  tasksCompleted: arr,
                  subPageTaskIndex: -1,
                  tasksRegistered: tasksRegisteredNext
                };
              });
            }
          },
          onCompleted: function onCompleted(value, id) {
            DEBUG && console.log("Page context onCompleted", value, id, "subPageTaskIndex", _this3.state.subPageTaskIndex);
            _this3.setState(function (state, props) {
              if (id === undefined) {
                id = state.subPageTaskIndex;
                if (id === -1) {
                  id = state.tasksCompleted.length - 1;
                }
              }
              var arr = state.tasksCompleted.slice();
              arr[id] = value;
              DEBUG && console.log("Page context onCompleted setState", arr, "subPageTaskIndex", state.subPageTaskIndex);
              return {
                tasksCompleted: arr
              };
            });
          }
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: this.ref,
        className: "page",
        style: {
          padding: (_this$props$style$pad = (_this$props$style = this.props.style) === null || _this$props$style === void 0 ? void 0 : _this$props$style.padding) !== null && _this$props$style$pad !== void 0 ? _this$props$style$pad : "20px 0px"
        },
        id: "page-" + this.state.index,
        role: "document",
        tabIndex: -1
      }, debugPages && this.state.tasksCompleted.map(function (v, k) {
        return /*#__PURE__*/_react.default.createElement("input", {
          key: k,
          type: "checkbox",
          readOnly: true,
          checked: v
        });
      }), debugPages && (this.state.completed ? '◯' : '✖'), children.map(function (child, index) {
        if (child.type && child.type.prototype && child.type.prototype.isTask && child.type.prototype.isTask()) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            key: child.key || index
          });
        } else if (child.type && child.type.prototype && child.type.prototype.isPage && child.type.prototype.isPage()) {
          if (_this3.state.shouldShowSubPage) {
            return /*#__PURE__*/_react.default.cloneElement(child, {
              key: child.key || index
            });
          } else {
            return null;
          }
        }
        return child;
      })));
    }
  }]);
  return Page;
}(_react.Component);
Page.contextType = _CompletedContext.default;